import { general } from 'constants/assets'
import { url } from 'constants/urls'
import clsx from 'clsx'
import { useTranslation } from 'i18n/useTranslation'
import { Link } from 'react-router-dom'

export const RenderAuthButton = ({
  isLoggedIn,
  redirectLoginUrl,
  toggleMobileMenu
}: {
  isLoggedIn: boolean
  redirectLoginUrl: string
  toggleMobileMenu: () => void
}) => {
  const { navbarTranslations } = useTranslation()
  return (
    <li
      className={clsx(
        'flex h-[64px] border-b border-separator font-bold transition-all duration-200 hover:brightness-125 lg:border-none',
        !isLoggedIn && 'border-b-0'
      )}
    >
      <Link
        to={isLoggedIn ? url.redirectDashboard : redirectLoginUrl}
        target='_blank'
        rel='noopener noreferrer'
        onClick={() => toggleMobileMenu()}
        className='flex w-full items-center font-poppins text-[17.5px] tracking-normal'
      >
        {isLoggedIn ? (
          <div className='flex flex-row items-center gap-2'>
            <img
              src={general.userIcon}
              alt='user icon'
              className='h-[24px] w-[27px] lg:size-[40px]'
            />
            <div className='text-[17.5px] font-black lg:hidden'>
              {navbarTranslations.dashboard}
            </div>
          </div>
        ) : (
          <div className='flex w-full flex-row items-center justify-between uppercase tracking-wide hover:text-neon_yellow lg:text-[15.5px] xl:text-[17.5px]'>
            <div>{navbarTranslations.signIn}</div>
            <img
              src={general.arrowDown}
              alt='arrow down'
              className=' -rotate-90 sm:hidden'
            />
          </div>
        )}
      </Link>
    </li>
  )
}
